import { WithRef } from "@converge-collective/common/models/Base";
import {
  Network,
  NetworkMembership,
} from "@converge-collective/common/models/Network";
import { modelFromSnap } from "@converge-collective/common/util";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useFirestore, useUser } from "reactfire";

export function useNetworkMembership(): WithRef<NetworkMembership> | undefined {
  const [networkMembership, setNetworkMembership] =
    useState<WithRef<NetworkMembership>>();

  const router = useRouter();
  const firestore = useFirestore();
  const { data: user } = useUser();
  const networkToFetch = router?.query?.network;

  useEffect(() => {
    const fetchNetworkMembership = async () => {
      console.log("fetchNetworkMembership", { user, router, networkToFetch });
      if (user) {
        const profileRef = firestore.doc(`profiles/${user.uid}`);
        const query = firestore
          .collectionGroup("members")
          // filtering to networks that the current user is a member of
          .where("profileRef", "==", profileRef)
          .where("network.slug", "==", networkToFetch);
        const results = await query.get();
        if (!results.empty) {
          const [firstDoc] = results.docs;
          const nm = modelFromSnap<NetworkMembership>(firstDoc);
          setNetworkMembership(nm);
        }
      }
    };
    networkToFetch && fetchNetworkMembership();
  }, [user, router, networkToFetch]);

  return networkMembership;
}
